import {
  EventDataFragment,
  useDeleteConsultantEventLogEntryMutation
} from "@bonliva-crm/graphql";
import { HookProps } from "../utils/hook-props";

export function useDeleteConsultantEventLogEntry(props: HookProps) {
  const [deleteConsultantEventLogEntryMutation] =
    useDeleteConsultantEventLogEntryMutation({
      onError: (error) => {
        console.error(error);
        props.onError && props.onError(error);
      },
      onCompleted: () => {
        props.onCompleted && props.onCompleted();
      }
    });

  const deleteConsultantEventLogEntry = ({ event }: { event: EventDataFragment }) => {
    props.onBeforeCall && props.onBeforeCall();
    deleteConsultantEventLogEntryMutation({
      variables: { eventId: event._id },
      optimisticResponse: () => {
        return {
          deleteConsultantEvent: {
            ...event,
            UpdatedBy: null,
            Deleted: true
          }
        };
      }
    });
  };

  return { deleteConsultantEventLogEntry };
}
